import actions from 'circe/listing/actions';
import actionTypes from './actionTypes';

export const {
  fetch, fetchNext, fetchPrev, fetched, fetching, cache,
} = actions(actionTypes);

export const create = data => ({
  type: actionTypes.CREATE,
  payload: {
    data,
  },
});

export const created = data => ({
  type: actionTypes.CREATED,
  payload: {
    data,
  },
});

export const createFailed = () => ({
  type: actionTypes.CREATE_FAILED,
});

export const revoke = id => ({
  type: actionTypes.REVOKE,
  payload: {
    id,
  },
});

export const revoked = (id, data = {}) => ({
  type: actionTypes.REVOKED,
  payload: {
    id,
    data,
  },
});

export const revokeFailed = id => ({
  type: actionTypes.REVOKE_FAILED,
  payload: {
    id,
  },
});

export const replenish = (id, data) => ({
  type: actionTypes.REPLENISH,
  payload: {
    id,
    data,
  },
});

export const replenished = (id, data = {}) => ({
  type: actionTypes.REPLENISHED,
  payload: {
    id,
    data,
  },
});

export const replenishFailed = id => ({
  type: actionTypes.REPLENISH_FAILED,
  payload: {
    id,
  },
});

export const invoiceCreate = (id, data) => ({
  type: actionTypes.INVOICE_CREATE,
  payload: {
    id,
    data,
  },
});

export const invoiceCreated = (id, data = {}) => ({
  type: actionTypes.INVOICE_CREATED,
  payload: {
    id,
    data,
  },
});

export const invoiceCreateFailed = id => ({
  type: actionTypes.INVOICE_CREATE_FAILED,
  payload: {
    id,
  },
});

export const activate = id => ({
  type: actionTypes.ACTIVATE,
  payload: {
    id,
  },
});

export const activated = (id, data) => ({
  type: actionTypes.ACTIVATED,
  payload: {
    id,
    data,
  },
});

export const activateFailed = id => ({
  type: actionTypes.ACTIVATE_FAILED,
  payload: {
    id,
  },
});
